export const DEFAULT_COMPONENTS = {
  preventBrowserAutocomplete: false,
  defaultPaymentType: "",
  paymentTypes: [""],
  startOnLoad: false,
  callbacks: {},
  accountFundingTransfer: {
    customerAccountNumberType: "AUTO" as const,
  },
};
